module.exports = __webpack_public_path__ + "img/homebg03.067c3882.svg";